import { isEmpty } from "lodash";
import { Constant } from "../../../constants/constant";

export function propsToInitialState(data) {
  const dataInit = { ...data };
  dataInit.ngay = data?.ngay || null;
  dataInit.thang = data?.thang || null;
  dataInit.nam = data?.nam || null;
  dataInit.phuongXa = data?.donViHanhChinh_Xa || null;
  dataInit.quanHuyen = data?.donViHanhChinh_Huyen || null;
  dataInit.tinhThanh = data?.donViHanhChinh_Tinh || Constant.TINHTHANH;
  dataInit.nhietDo = data?.nhietDo || null;
  dataInit.luongMua = data?.luongMua || null;
  dataInit.doAm = data?.doAm || null;
  dataInit.soGioNang = data?.soGioNang || null;
  return dataInit;
}

export function parseDataSave(value) {
  const dataSave = { ...value };
  dataSave.ngay = value?.ngay || 0;
  dataSave.thang = value?.thang || 0;
  dataSave.nam = value?.nam || 0;
  dataSave.maTinh = value?.tinhThanh?.maTinh || null;
  dataSave.maHuyen = value?.quanHuyen?.maHuyen || null;
  dataSave.maXa = value?.phuongXa?.maXa || null;
  dataSave.nhietDo = value?.nhietDo || 0;
  dataSave.luongMua = value?.luongMua || 0;
  dataSave.doAm = value?.doAm || 0;
  dataSave.soGioNang = value?.soGioNang || 0;
  return dataSave;
}
